<div
  class="flex w-32 max-w-32 cursor-default items-center justify-start gap-1 rounded-full px-2 py-1 hover:brightness-90"
  [ngClass]="classList()"
  [matTooltip]="tooltip()">
  <mat-icon class="qaroni-mat-icon-20 shrink-0">{{ icon() }}</mat-icon>
  <span class="truncate text-sm font-normal">{{ name() }}</span>
</div>
